import { Component, Prop } from 'vue-property-decorator'
import Checkup from '@src/data/checkup'
import { API } from '@src/lib/api_path'
import { snakecaseKeys } from '@src/util/functions'
import { HealthLimitations } from '@src/routes/members/components/health-limitations/health-limitations'
import { HealthLimitationService } from '@src/service/health-limitation'
import ApiClient from '@src/lib/api_client'

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    }
  }
})
export class WizardHealthLimitations extends HealthLimitations {

  @Prop({ required: false, default: false })
  protected isReadonly: boolean

  protected checkup: Checkup

  constructor () {
    super()
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.CHECKUPS')}`
  }

  load (): Promise<void> | undefined {
    if (this.checkup.healthLimitationsSetId) {
      // load the health limitations in the checkup
      return this.loadHealthLimitationSet(this.checkup.healthLimitationsSetId)

    } else if (!this.isReadonly) {
      // render the latest health limitations set
      return this.loadLatestHealthLimitations()
    }
  }

  beforeDestroy () {
    if (!this.isReadonly) {
      return this.addHealthLimitationSet()
    }
  }

  protected loadHealthLimitationSet (healthLimitationId: number) {
    return new HealthLimitationService().loadHealthLimitationSet(healthLimitationId, this.$route.params.id)
      .then((response) => {
        this.healthLimitationsSet = response
        this.loading = false
      })
      .finally(() => this.assignHealthLimResponseToData())
  }

  protected addHealthLimitationSet () {
    if (this.isUpdated || !this.checkup.healthLimitationsSetId) {
      return new HealthLimitationService().addHealthLimitationSet(this.healthLimitationsSet, this.$route.params.id)
        .then((responseSet) => {
          if (responseSet.id) return this.updateCheckup(responseSet.id)
        })
    } else {
      return this.updateCheckup(this.checkup.healthLimitationsSetId)
    }
  }

  protected async updateCheckup (healthLimitationId) {
    let checkup = new Checkup(this.checkup)
    checkup.healthLimitationsSetId = healthLimitationId
    checkup.healthLimitationsSetAdded = true
    checkup.updateState()
    this.$store.dispatch('setCheckup', checkup)

    await new ApiClient().put(`${API.TRAINERS_API.CHECKUPS.replace('{memberId}', this.$route.params.id)}/${checkup.id}`, { checkup: snakecaseKeys(checkup) })
      .catch(err => console.error('Failed to update checkup, ', err))
  }
}
